







import { Component, Vue } from 'vue-property-decorator';
import MenuList from './menuList.vue';

@Component({
  components: {
    MenuList,
  },
})
export default class SideBar extends Vue {
  public collapsed: boolean = false;
  private toggleSidebar() {
    this.collapsed = !this.collapsed;
  }
}
